<template>
  <div class="flex-container d-flex flex-column ai-center bg-dark color-white">
    <div class="section-wrapper d-flex flex-column ai-center">
      <div class="mg-150"></div>
      <div class="header-2 kor">사업 진행 절차</div>
      <div class="flex-container d-flex ai-center jc-center mg-50">
        <v-img class="mr-5" contain :height="50" :max-width="50" :src="quote" />
        <div class="text-center text-lg">
          <b>ALL about "데이터바우처 지원사업"</b><br />
          전문 컨설턴트 데이터몬스터즈가 함께합니다!
        </div>
        <v-img
          class="rotate-180 ml-5"
          contain
          :height="50"
          :max-width="50"
          :src="quote"
        />
      </div>
      <div class="mg-50" />
      <div class="flex-container d-flex jc-center ai-center text-lg">
        <b class="mr-5 text-underline">접수기간</b>
        2021년 2월 26일 ~ 4월 16일
      </div>
      <div class="mg-50" />
      <div class="flex-container d-flex jc-between ai-center">
        <div class="d-flex flex-column ai-center">
          <div class="progress-item">
            <b class="text-lg">접수 신청</b>
            <span>2/26 ~ 4/16</span>
          </div>
          <v-img class="arrow-down" :width="20" :src="arrow" />
          <div class="text-center text-lg">
            <b
              >K-data<br />
              홈페이지 공고</b
            >
          </div>
        </div>
        <div class="d-flex flex-column ai-center">
          <div class="progress-item">
            <b class="text-lg text-center">
              선정 평가 및 <br />
              협약 체결
            </b>
            <span>4/19 ~ 6/18</span>
          </div>
          <v-img class="arrow-down" :width="20" :src="arrow" />
          <div class="text-center text-lg">
            <b
              >서류 및 발표 심사<br />
              및 3자 협약 체결</b
            >
          </div>
        </div>
        <div class="d-flex flex-column ai-center">
          <div class="progress-item">
            <b class="text-lg">사업 수행</b>
            <span>6/21 ~ 11/22</span>
          </div>
          <v-img class="arrow-down" :width="20" :src="arrow" />
          <div class="text-center text-lg mb-7">
            <b>데이터 활용 지원</b>
          </div>
        </div>
        <div class="d-flex flex-column ai-center">
          <div class="progress-item">
            <b class="text-lg">점검 평가</b>
          </div>
          <v-img class="arrow-down" :width="20" :src="arrow" />
          <div class="text-center text-lg">
            <b
              >사업 이행점검,<br />
              우수 사례 공유</b
            >
          </div>
        </div>
      </div>
      <div class="mg-150" />
      <router-link to="/datavoucher/inquiry">
        <v-btn x-large width="500" outlined color="white"
          ><b>사업문의 하러가기</b></v-btn
        >
      </router-link>
      <div class="mg-150" />
    </div>
  </div>
</template>

<script>
import arrow from "@/assets/arrow.svg";
import quote from "@/assets/quote.svg";
export default {
  data: () => ({
    arrow,
    quote,
  }),
};
</script>

<style>
</style>